$(document).ready(function(){

  $('.collection-menu-filters summary.facets__summary.filter-parent-summary').on('click', function(){
    $(this).next(".filter-menu").toggleClass('hidden');
  });

  $('.collection-menu-filters details summary').on('click', function(){
    $(this).closest('details').siblings().find('summary').removeClass('active');
    $(this).toggleClass('active');
  });

  $('.filter-submenu-summary').click(function(e) {
    e.preventDefault();
    var parentDetails = $(this).closest('details');
    $('details.filter-submenu-details').not(parentDetails).removeAttr('open');
    $('details.filter-submenu-details').not(parentDetails).find('summary').removeClass('active');
    if (parentDetails.attr('open')) {
      parentDetails.removeAttr('open'); 
      $(this).removeClass('active'); 
    } else {
      parentDetails.attr('open', true); 
      $(this).addClass('active');    
    }
  });
  
  $('.filter-subsubmenu-summary').click(function(e) {
    e.preventDefault(); 
    var subDetails = $(this).closest('details');
    $('details.filter-subsubmenu-details').not(subDetails).removeAttr('open');
    $('details.filter-subsubmenu-details').not(subDetails).find('summary').removeClass('active');
    if (subDetails.attr('open')) {
      subDetails.removeAttr('open');
      $(this).removeClass('active');
    } else {
      subDetails.attr('open', true);
      $(this).addClass('active');
    }
  });

  // hover effect header menu
  function bindMouseOverToMegaMenu (item) {
  
    item.addEventListener("mouseover", () => {
      item.classList.add('mega-nav-first');
      item.setAttribute("open", true);
      
      item.addEventListener("mouseleave", () => {
        item.classList.remove('mega-nav-first');
        item.removeAttribute("open");
      });
    });

  }
      
  let items = document.querySelectorAll(".header__inline-menu details.mega-menu");
  items.forEach(bindMouseOverToMegaMenu);
  
  // announcement bar slider
  $('.announcement_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.2833 0C10.4021 0 10.5236 0.0469492 10.6147 0.138072C10.797 0.320318 10.797 0.618543 10.6147 0.800789L4.37683 7.04143L10.5236 13.1882C10.7058 13.3704 10.7058 13.6687 10.5236 13.8509C10.3413 14.0332 10.0431 14.0332 9.86088 13.8509L3.38278 7.3728C3.20053 7.19056 3.20053 6.89232 3.38278 6.71007L9.952 0.138086C10.0431 0.0469629 10.1646 2.73438e-05 10.2834 2.73438e-05L10.2833 0Z' fill='white'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.71666 0C3.59792 0 3.47641 0.0469492 3.38529 0.138072C3.20305 0.320318 3.20305 0.618543 3.38529 0.800789L9.62317 7.04143L3.47641 13.1882C3.29417 13.3704 3.29417 13.6687 3.47641 13.8509C3.65866 14.0332 3.95687 14.0332 4.13912 13.8509L10.6172 7.3728C10.7995 7.19056 10.7995 6.89232 10.6172 6.71007L4.048 0.138086C3.95687 0.0469629 3.8354 2.73438e-05 3.71664 2.73438e-05L3.71666 0Z' fill='white'/></svg></div>",
  });
  
  //product page slider
  $('.slider-for').slick({
    prevArrow: "<div class='product pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
    nextArrow: "<div class='product next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",  
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: false,
    asNavFor: '.slider_thum'
  });
  
 $(".slider_thum").slick({
   dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      vertical: true,
      asNavFor: '.slider-for',
      focusOnSelect: true,
      responsive: [
    {
      breakpoint: 767,
      settings: {
      vertical: false,
       slidesToShow: 3,
      },
    },
  ],
   
  });
    
  //product page slider image change swtach
  $('input.custom_swatch').click(function(){
      setTimeout(function() { 
    var current_url = window.location.href;
    var current_url_split = current_url.split('?')[1];
    var current_url_split_new = current_url_split.split('=')[1];
     
      $('.colors_variants').each(function(){
          var variants_id = $(this).attr('variants-id');
         if(current_url_split_new == variants_id ) {
            var selected_image = $(this).attr('varinat-image');
            var selected_image_new = selected_image.split('/')[6];
            var selected_image_new1 = selected_image_new.split('?')[0];
            
               $('.custon_images_variants').each(function(){
                  var variants_slider_img = $(this).attr('src');
                  
              if(variants_slider_img.includes(selected_image_new1)){
                  $(this).trigger('click'); 
              }
           
             });
          
         }
      });

    }, 500);
  });
  
  //active size product page
  $('input.custom_swatch.size').click(function(){
      var selected_val = $(this).attr('value');
    $(this).parents('.size').find('.form__label').html('Size: '+ selected_val);
   $(this).next('.custom-swatch_var').toggleClass('active');
    $('input.custom_swatch.size').not(this).next('.custom-swatch_var').removeClass('active');
  });
  
  // product page tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    
    $(this).find('a').click(function(e){
      active.removeClass('active');
      active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  
    $(this).find('.reviews').click(function(e){
      $(this).parents('.cgt-desc').find('.main-content').removeClass('cgt-content');
    });
   
 });

  $('.apps_enabled').hide();
  $('#pr-reviewdisplay').hide();
  $('#pr-questiondisplay').hide();

  $('a.reviews').click(function(){
    $('.apps_enabled').show();
    $('#pr-reviewdisplay').show();
    $('#pr-questiondisplay').hide();
  });

  $('a.questions').click(function(){
    $('.apps_enabled').show();
    $('#pr-questiondisplay').show();
    $('#pr-reviewdisplay').hide();
  });
    
  $('a.description.active').click(function(){
    $('.apps_enabled').hide();
    $('#pr-reviewdisplay').hide();
    $('#pr-questiondisplay').hide();
  });

  $("a.specification").click(function(){
    $('.apps_enabled').hide();
    $('#pr-reviewdisplay').hide();
    $('#pr-questiondisplay').hide();
  });
  
//first active size product
  $('fieldset.js.product-form__input.size').find('.custom_swatch').eq(0).trigger("click");

});


if (document.body.classList.contains('custom-product')) {
  $(window).scroll(function() {
    var originalButton = $('.product.product--medium');
    var stickyButton = $('.main_of_stickey');
    if ($(window).scrollTop() > originalButton.offset().top) {
        stickyButton.show();
    } else {
        stickyButton.hide();
    }
  });
  $('button#btn-sticky-cart').on('click', function(){
  $('product-form.product-form').find('.product-form__buttons .product-form__submit').click();
  }); 
}

$('.recommendation-addToCart-btn').on('click', function(){
  var id = $(this).closest('.recommendation-product-grid-detail').find('.recommendation-product-id').attr('value');
  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let subItem = {
      id: String( id ),
      quantity: 1,
      sections:cart.getSectionsToRender().map((section) => section.id),
      sections_url:window.location.pathname
    };
  let body = JSON.stringify(subItem);
  fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
  .then((response) => response.json())
  .then((response) => {
      cart.renderContents(response);
  });
});


// Product Page Recomandation section code end
// recommendation-grid-slider
  // $('.recommendation-product-grid-container.recommendation-grid-slider').slick({
  // dots: false,
  // infinite: false,
  // speed: 300,
  // prevArrow:'<span class="slick_arrows prev-arrow"><svg class="slick_arrows prev-arrow" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg></span>',
  // nextArrow:'<span class="slick_arrows next-arrow"><svg  class="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></span>',
  // slidesToShow: 2,
  // slidesToScroll: 1,
  // responsive: [
  // {
  // breakpoint: 767,
  // settings: {
  //   slidesToShow: 2,
  //   slidesToScroll: 1
  // }
  // },
  // {
  // breakpoint: 480,
  // settings: {
  //   slidesToShow: 2,
  //   slidesToScroll: 1
  // }
  // }
  // ]
  // });
// recommendation-grid-slider code end

//<!---------- Collection Fillter JS Start ---------->

$('.tag-filter-filters details summary').on('click', function(){
    $(this).closest('details').siblings().find('summary').removeClass('active');
    $(this).toggleClass('active');
});


$(document).ready(function() {
  // Check if the window width is less than or equal to 750px
  if ($(window).width() <= 750) {
    // Attach a click event handler to the .filter-menu_heading elements
    $('.filter-menu_heading').on('click', function() {
      // Find the closest .collection-menu-filters element
      var $filters = $(this).closest('.collection-menu-filters');

      // Toggle the height of .collection-menu-filters between 100% and auto
      if ($filters.hasClass('expanded')) {
        $filters.css('height', 'auto').removeClass('expanded');
      } else {
        $filters.css('height', '100%').addClass('expanded');
      }
    });
  }
});

$(document).on('click', 'facet-remove.active-facets__button-wrapper', function(e){
     e.preventDefault();
     var mainhref  =  $(this).find('a').attr('href');
     window.location.replace(mainhref);
    });

//<!---------- Collection Fillter JS End ---------->
if (window.matchMedia('(max-width: 750px)').matches) {
    $(document).ready(function() {
        $('.custom-svg-filter').removeClass('active');
        $(this).next('ul.tag-filters').toggleClass('activesss');
      $('.custom-svg-filter').each(function() {
        $(this).on('click', function() {
            $(this).toggleClass('active');
            $(this).next('ul.tag-filters').toggleClass('activesss');
        });
      });
    });
}else{
  $(document).ready(function() {
  $('.custom-svg-filter').each(function() {
    $(this).on('click', function() {
        $(this).toggleClass('active');
        $(this).next('ul.tag-filters').toggleClass('hide');
    });
  });
});
}
//<!---------- Collection Fillter JS End ---------->

// Override Wishlist Hero MUI Snackbar auto-hide
(function waitForWishlistHero() {
  const originalSetTimeout = window.setTimeout;

  // Intercept all setTimeout calls
  window.setTimeout = function(callback, delay) {
    // Wishlist Hero always uses small delays for auto-hide (2000–6000)
    if (
      typeof callback === 'function' && 
      delay > 1500 && 
      delay < 7000
    ) {
      console.log("Wishlist Hero auto-hide blocked:", delay);
      return; // CANCEL THE AUTO-HIDE TIMER
    }

    return originalSetTimeout(callback, delay);
  };

  console.log("Wishlist Hero auto-hide interceptor active");
})();

